import {NgModule} from "@angular/core";
import { CommonModule } from '@angular/common';

import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ConfigToolsComponent} from "./configTools.component";
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';

@NgModule({
  declarations: [ConfigToolsComponent],
  imports     : [ CommonModule, 
                  ButtonModule,
                  FileUploadModule,
                  TooltipModule,
                  RippleModule,
                  BsDropdownModule.forRoot()
                ],
  exports     : [
    ConfigToolsComponent
                ],  
})

export class ConfigToolsModule {}
